import * as React from 'react';

import * as main from '../../../styles/main.module.scss';
import * as useful from './useful.module.scss';

export const Useful = () => {
  return (
    <section className={useful.useful}>
      <div className={"container"}>
        <p className={useful.useful__text}>У каждого человека наступает момент, когда следующая работа оказывается хуже предыдущей.</p>
        <p className={useful.useful__text}>Момент, когда возраст из преимущества становится недостатком. Когда на обучение нет сил. Когда нужно много учиться, чтобы просто не отстать. А догнать молодых кажется невозможным.</p>
        <div className={useful.useful__wrapper} id={"useful"}>
          <h2 className={`${main.mainTitle} ${useful.useful__title}`}>Вебинар будет полезен, если</h2>
          <ul className={useful.useful__list}>
            <li className={useful.useful__item}>
              <img
                className={useful.useful__itemImg}
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/icon-calendar.svg"}
                alt={""}
              />
              <p className={useful.useful__itemText}>вы поняли,<br/>что ещё 10-30 лет такой жизни существенно ничего не изменят</p>
            </li>
            <li className={useful.useful__item}>
              <img
                className={useful.useful__itemImg}
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/icon-clock.svg"}
                alt={""}
              />
              <p className={useful.useful__itemText}>вы устали бояться, что перемены обнулят ваши достижения</p>
            </li>
            <li className={useful.useful__item}>
              <img
                className={useful.useful__itemImg}
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/icon-coins.svg"}
                alt={""}
              />
              <p className={useful.useful__itemText}>вы точно знаете, что, когда выйдете на пенсию, её не хватит даже на половину нынешнего уровня жизни</p>
            </li>
          </ul>
          <div className={useful.useful__mainThoughts}>
            <img
              className={useful.useful__mainImg}
              src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/sadphoto.png"}
              alt={""}
            />
            <div>
              <p className={useful.useful__mainText}><strong>И главное: вы уже много раз пробовали это изменить</strong></p>
              <p className={useful.useful__mainText}>Честно пробовали: записывались на курсы, возможно, получили второе или третье высшее образование, старались, и всё равно ничего не получилось</p>
              <a href={"#widget"} data-target={"#widget"} className={main.mainBtn}>Зарегистрироваться</a>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};
